(ns frontend.view.kpi-reporting.kpi-company-reports.company-sidenav
  (:require
   [frontend.state.current-session :as session]
   [frontend.view.kpi-reporting.kpi-company-reports.events :as events]
   [frontend.view.kpi-reporting.kpi-company-reports.db :as db]
   [potpuri.core :refer [fn-> fn->> index-by deep-merge]]
   [common.util :as cu]
   [frontend.utils :as fu]
   [frontend.bootstrap.components :as rbs]))

(defn view
  [view-args]
  (fn
    [{:keys [company-id companies selected-report-id reports
             minimized? hide-minimize? cycle-selected?
             select-company! select-report! toggle-minimize!]
      :as   view-args}]
    (let [session-entities @session/entities
          company (get session-entities company-id)
          ;;member-entities that points to given company
          member-entities (->> @session/all-kpi-members
                               (cu/only-entity :kpi-member/asset company-id)
                               (remove :common/disabled?))
          ;;all the categories
          categories (->> @session/all-kpi-categories
                          (remove :common/disabled?))
          cycles (->> @session/all-kpi-cycles
                      (remove :common/disabled?))
          category-ids (->> categories
                            (map :db/id)
                            set)
          category-members (->> member-entities
                                (filter (fn->> :kpi-member/target (contains? category-ids))))
          member-categories (->> member-entities
                                 (map :kpi-member/target)
                                 (map (fn->> (get session-entities))))]
      [:div
       {:class-name (str "named-views-sidenav")}
       [:div
        {:class-name "px-4"}
        [:div.named-views-content 
         {:class "pb-6 flex flex-col gap-2"}
         (doall
          (for [member category-members
                :let [member-id (:db/id member)
                      category-id (->> member
                                       :kpi-member/target)
                      category (get session-entities category-id)

                      category-cycles (->> cycles
                                           (cu/only-entity :kpi-cycle/kpi-category category-id))
                      category-cycle-ids (->> category-cycles
                                              (map :db/id)
                                              set)
                      category-reports (->> reports
                                            (filter (fn->> :kpi-report/kpi-cycle
                                                           (contains? category-cycle-ids))))
                      company-cycles
                      (->> category-cycles
                           (remove
                            (fn [{:keys [db/id]}]
                              (let [cycle-reports (->> reports
                                                       (cu/only-entity :kpi-report/kpi-cycle id))]
                                (empty? cycle-reports))))
                           (sort-by (juxt :kpi-cycle/target-year :kpi-cycle/target-month))
                           reverse)]]
            (when-not (empty? category-reports)
              ^{:key (str "category-item-" member-id)}
              [:div.kpi-sidenav-category
               [:h3 (:kpi-category/name category)]
               (for [cycle company-cycles
                     :let [cycle-id (:db/id cycle)
                           report (->> reports
                                       (cu/only-entity :kpi-report/kpi-cycle cycle-id)
                                       first)
                           status (:kpi-report/status report)
                           selected? (= (:db/id report) selected-report-id)]]
                 ^{:key (str "cycle-item-" (:db/id cycle))}
                 [:div
                  {:class-name (str "named-view-container"
                                    (when selected? " selected"))
                   :on-click   (fn [_]
                                 ;;TODO switch to using cycles?
                                 (events/select-report! (:db/id report)))}
                  [:span
                   {:class-name (fu/cs "report-indicator"
                                       (when status
                                         (name status)))}
                   [:span.report-dot.small]]
                  " "
                  (:kpi-cycle/name cycle)])])))]]])))
